<template>
    <div>
        <el-form :model="loginForm" :rules="rules" label-width="100px" ref="loginForm">
            <el-form-item label="用户名" prop="username">
                <el-input v-model="loginForm.username"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="loginForm.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
                <el-button @click="resetForm('loginForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import api from '@/axios.js'

export default {
    data(){
        return {
            activeName: 'login', //选项卡
            loginForm: {        //表单v-model的值
                username: '',
                password: ''
            },
            rules: { //验证规则
                username: [
                    { required: true, message: '用户名不能少', trigger: 'blur'},
                    { min: 5, max: 16, message: '用户名在6到16位之间', trigger: 'blur'}
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        resetForm(formName){
            this.$refs[formName].resetFields();
        },
        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if(valid){ //验证通过
                    let opt = this.loginForm;
                    api.userLogin({
                        name: opt.username,
                        pwd: opt.password
                    }).then(({ data }) => {     //解构赋值拿到data
                            if(data.code != "200"){//账号不存在
                                this.$message({
                                    type: 'info',
                                    message: '用户名或密码错误'
                                });
                                return ;
                            } else {
                                this.$message({
                                    type: 'success',
                                    message: '登录成功'
                                })
                                let token = data.token;
                                // let username = data.username;
                                let username = opt.username;
                                this.$store.dispatch('UserLogin', token);
                                this.$store.dispatch('UserName', username);
                                //如果用户手动输入"/"那么会跳转到这里来，即this.$route.query.redirect有参数
                                let redirectUrl = decodeURIComponent(this.$route.query.redirect || '/admin');
                                //跳转到指定的路由
                                this.$router.push({
                                    path: redirectUrl
                                });
                            }
                        });
                }else{ 
                    //验证不通过
                    return false;
                }
            });
        }
    }
}
</script>

<style scoped>
.el-form {
    width: 500px;
    margin: 0 auto;
    padding-top: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/server_web/login/login.vue